<div class="menu-item my-5">
    <a class="menu-link rounded" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
        <span class="menu-icon ">
            <span [inlineSVG]="'./assets/media/icons/duotune/general/gen025.svg'" class="svg-icon svg-icon-2 "></span>
        </span>
        <span class="menu-title ">
            Dashboard
        </span></a>
</div>


<div class="menu-item">
    <a class="menu-link rounded" routerLink="/reports" routerLinkActive="active">
        <span class="menu-icon">
            <span [inlineSVG]="'./assets/media/icons/duotune/general/gen019.svg'" class="svg-icon svg-icon-2"></span>
        </span>
        <span class="menu-title">
            Reports
        </span>
    </a>
</div>